import { NotFound } from 'components/common/NotFound';
import EatingWayFeature from 'features/EatingWay';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import SaleTypeListPage from './pages/SaleTypeListPage';

function SaleTypeFeature() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Redirect to={`${path}/sale-type-list`} />
      </Route>
      <Route path={`${path}/sale-type-list`}>
        <SaleTypeListPage />
      </Route>
      <Route path={`${path}/eating-way`}>
        <EatingWayFeature />
      </Route>
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  );
}

export default SaleTypeFeature;
